// src/bootstrap/loadCartWidget.ts
import { createApp } from 'vue'
import { createPinia } from 'pinia'
import CartWidgetApp from '../CartWidgetApp.vue'
import type { WidgetProps } from '../runtime/widgetConfig'
import { getWidgetConfig, setWidgetConfig } from '../runtime/widgetConfig'
import { applyWidgetTheme } from '../runtime/applyWidgetTheme'

export async function loadCartWidget(args: { mountEl: Element; props: WidgetProps }) {
    const { mountEl, props } = args

    // ✅ Ensure config is set even if widget-entry forgot to do it
    setWidgetConfig(props)
    applyWidgetTheme(mountEl, getWidgetConfig())

    const app = createApp(CartWidgetApp, props)
    app.use(createPinia())
    app.mount(mountEl)
    return app
}
